import { store } from '@/decorators/store';
import { CompanyLinking } from '@/entities/CompanyLinking';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

export interface IShareTenants {
  sharedTenantKey: string;
  sharedTenantName: string;
}

export interface IFeaturePermissions {
  dispatchBridgeKey: string;
  tenantKey: string;
  bridgeName: string;
  googleGeocoding: boolean;
  apiAccess: boolean;
  modifiedByUserKey: string;
  googleApiKey: string;
  googleApiKey_custom: string;
  googleApiKey_global: string;
}

@store({ id: 'CompanyConfigurationStore' })
export class CompanyConfigurationStore extends AbstractEntityStore<CompanyLinking> {
  protected entityIdKey = 'externalKey';
  protected entityLabelKey = 'itemName';
  protected entityValueKey = 'itemName';

  protected sharedTenats: IShareTenants[] = [];
  protected featurePermissions: IFeaturePermissions | null = null;

  get featurePermissionSettings() {
    return this.featurePermissions;
  }

  setFeaturePermissionSettings(permissions: IFeaturePermissions | null) {
    this.featurePermissions = permissions;
  }

  get allSharedTenants() {
    return [...this.sharedTenats];
  }

  setSharedTenants(tenants: IShareTenants[]) {
    this.sharedTenats = tenants;
  }
}
